import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type {
  Folder,
  FolderCreateData,
  FolderListItem,
  FolderListParams,
  FolderUpdateData
} from "../types/folder.types.ts"

const BASE_URL = `/project-management/folders`

const PATHS = {
  list: `${BASE_URL}/`,
  create: `${BASE_URL}/`,
  read: (id: string) => `${BASE_URL}/${id}/`,
  update: (id: string) => `${BASE_URL}/${id}/`,
  delete: (id: string) => `${BASE_URL}/${id}/`
}

// GET /project-management/folders/
export const getFolders = async (params: FolderListParams) => {
  return request.api.get<
    BasePagination<FolderListItem>,
    BaseApiResponse<unknown>
  >(PATHS.list, params)
}

// POST /project-management/folders/
export const createFolder = async (data: FolderCreateData) => {
  return request.api.post<BaseApiResponse<Folder>, BaseApiResponse<unknown>>(
    PATHS.create,
    data
  )
}

// GET /project-management/folders/{id}/
export const getFolder = async (id: string) => {
  return request.api.get<Folder, BaseApiResponse<unknown>>(PATHS.read(id))
}

// PATCH /project-management/folders/{id}/
export const updateFolder = async (id: string, data: FolderUpdateData) => {
  return request.api.patch<BaseApiResponse<Folder>, BaseApiResponse<unknown>>(
    PATHS.update(id),
    data
  )
}

// DELETE /project-management/folders/{id}/ — refused (400) while the folder
// still holds files or subfolders; there is no cascade.
export const deleteFolder = async (id: string) => {
  return request.api.delete<BaseApiResponse<null>, BaseApiResponse<unknown>>(
    PATHS.delete(id)
  )
}
